export { Ng2CompleterModule } from "./ng2-completer.module";
export { CompleterCmp } from "./components/completer-cmp";
export { CompleterListItemCmp } from "./components/completer-list-item-cmp";
export { CompleterService } from "./services/completer-service";
export { localDataFactory, LocalDataFactoryProvider, remoteDataFactory, RemoteDataFactoryProvider } from "./services/completer-data-factory";
export { LocalData } from "./services/local-data";
export { RemoteData } from "./services/remote-data";
export { CompleterBaseData } from "./services/completer-base-data";
export { CtrCompleter } from "./directives/ctr-completer";
export { CtrDropdown } from "./directives/ctr-dropdown";
export { CtrInput } from "./directives/ctr-input";
export { CtrList } from "./directives/ctr-list";
export { CtrRow } from "./directives/ctr-row";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/ng2-completer/index.js
// module id = ../../../../ng2-completer/index.js
// module chunks = 3